import React from 'react';

class BackgroundImage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      staticUrl: props.staticUrl,
      background_type: props.background_type,
      background_image_url: props.background_image_url,
    };
  }

  shouldComponentUpdate(nextProps) {
    const bg = document.querySelector('#hu-background .hu-background-image');
    if (nextProps.background_type !== 'image')
      bg.className = bg.className.replace(/\sselected/g, '');
    else 
      bg.className = 'hu-background-image' + ' selected';
    return false;
  }

  render() {
    const { background_type } = this.props;
    const selected = background_type === 'image';

    return (
      <div className={ selected ? 'hu-background-image selected' : 'hu-background-image' }>
        <div className="background-image-filter selected"></div>
      </div>
    )
  }
}

export default BackgroundImage;


// WEBPACK FOOTER //
// ./app/js/components/background/BackgroundImage.js